import { useState, useEffect, useCallback } from "react";
import api from "../../../services/api";
import { STATUS_PAGAR, STATUS_RECEBER, mesAtual, anoAtual, hoje } from "../constants";

export function useFinanceiro(){
  const [aba, setAba]               = useState("pagar");
  const [abaVis, setAbaVis]         = useState("lista");
  const [contasPagar, setContasPagar]     = useState([]);
  const [contasReceber, setContasReceber] = useState([]);
  const [fluxo, setFluxo]           = useState(null);
  const [clientes, setClientes]     = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [filtroStatus, setFiltroStatus] = useState("");
  const [modalForm, setModalForm]   = useState(null);
  const [form, setForm]             = useState({});
  const [salvando, setSalvando]     = useState(false);
  const [mes, setMes]               = useState(mesAtual);
  const [ano, setAno]               = useState(anoAtual);
  const [modalPagar, setModalPagar] = useState(null);
  const [dataPag, setDataPag]       = useState(hoje);

  const carregar = useCallback(() => {
    setLoading(true);
    Promise.all([
      api.get("/financeiro/contas-pagar/?page_size=1000"),
      api.get("/financeiro/contas-receber/?page_size=1000"),
      api.get("/financeiro/caixa/fluxo/?mes="+mes+"&ano="+ano),
      api.get("/clientes/contatos/?page_size=1000"),
    ]).then(([cpRes,crRes,flRes,cRes])=>{
      setContasPagar(cpRes.data.results||cpRes.data);
      setContasReceber(crRes.data.results||crRes.data);
      setFluxo(flRes.data);
      const todos=cRes.data.results||cRes.data;
      setClientes(todos.filter(c=>c.tipo!=="FORNECEDOR"));
      setFornecedores(todos.filter(c=>c.tipo==="FORNECEDOR"));
    }).finally(()=>setLoading(false));
  }, [mes, ano]);

  useEffect(()=>{carregar();},[carregar]);

  const setF=(f,v)=>setForm(prev=>({...prev,[f]:v}));

  const salvarConta=async()=>{
    setSalvando(true);
    try{
      const dados={...form};
      if(aba==="pagar"){
        if(dados.fornecedor) dados.fornecedor=parseInt(dados.fornecedor);
        if(modalForm==="novo") await api.post("/financeiro/contas-pagar/",dados);
        else await api.put("/financeiro/contas-pagar/"+dados.id+"/",dados);
      } else {
        if(dados.cliente) dados.cliente=parseInt(dados.cliente);
        if(modalForm==="novo") await api.post("/financeiro/contas-receber/",dados);
        else await api.put("/financeiro/contas-receber/"+dados.id+"/",dados);
      }
      carregar();setModalForm(null);
    }catch(e){alert("Erro ao salvar.");}
    finally{setSalvando(false);}
  };

  const confirmarPagamento=async()=>{
    if(aba==="pagar") await api.post("/financeiro/contas-pagar/"+modalPagar.id+"/pagar/",{data_pagamento:dataPag});
    else await api.post("/financeiro/contas-receber/"+modalPagar.id+"/receber/",{data_recebimento:dataPag});
    setModalPagar(null);carregar();
  };

  const excluir=async(id)=>{
    if(!window.confirm("Excluir?")) return;
    if(aba==="pagar") await api.delete("/financeiro/contas-pagar/"+id+"/");
    else await api.delete("/financeiro/contas-receber/"+id+"/");
    carregar();
  };

  const abrirNovo=()=>{
    setForm(aba==="pagar"
      ?{descricao:"",categoria:"FORNECEDOR",fornecedor:"",valor:"",data_vencimento:"",status:"PENDENTE",observacoes:""}
      :{descricao:"",categoria:"VENDA",cliente:"",valor:"",data_vencimento:"",status:"PENDENTE",observacoes:""}
    );
    setModalForm("novo");
  };

  const lista=aba==="pagar"?contasPagar:contasReceber;
  const STATUS=aba==="pagar"?STATUS_PAGAR:STATUS_RECEBER;
  const filtrada=lista.filter(c=>!filtroStatus||c.status===filtroStatus);
  const totalPendente=lista.filter(c=>c.status==="PENDENTE").reduce((s,c)=>s+parseFloat(c.valor),0);
  const totalVencido=lista.filter(c=>c.status==="VENCIDO").reduce((s,c)=>s+parseFloat(c.valor),0);

  return {
    aba, setAba, abaVis, setAbaVis,
    contasPagar, contasReceber, fluxo, clientes, fornecedores, loading,
    filtroStatus, setFiltroStatus,
    modalForm, setModalForm, form, setForm, salvando,
    mes, setMes, ano, setAno,
    modalPagar, setModalPagar, dataPag, setDataPag,
    setF, salvarConta, confirmarPagamento, excluir, abrirNovo,
    lista, STATUS, filtrada, totalPendente, totalVencido,
  };
}
